import axios from 'axios'
import { getS3BucketKulapUtilityFileUrl } from '@/environments'

const awsS3Api = axios.create({
  baseURL: getS3BucketKulapUtilityFileUrl(),
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 12000
})
export default class AwsS3APIProvider {
  getCountries () {
    return awsS3Api.get('/countries.json')
  }
  getProvincesInThailand () {
    return awsS3Api.get('/provincesInThailand.json')
  }
  getOccupationList () {
    return awsS3Api.get('/occupationList.json')
  }
  getAverageIncomeList () {
    return awsS3Api.get('/averageIncomeList.json')
  }
  getBusinessList () {
    return awsS3Api.get('/businessList.json')
  }
  getKycTopicsList () {
    return awsS3Api.get('/verifyTopicList.json')
  }
}



// WEBPACK FOOTER //
// ./src/resources/awsS3Api.js